import { api } from '../../apiAxios';
import { urlHttpGov } from '../../urls';
import { getToken } from '../../LStorage/token';

class MembrosService {
    private baseURL: string = `${urlHttpGov}${process.env.REACT_APP_BACKEND === 'local' ? '' :'/gestor'}/member`;

    async getGestorMembro(id: string | number, signal: AbortSignal): Promise<any> {

        let { data } = await api.get(`${this.baseURL}/entity/${id}`,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }


    async postGestorMembro(
        obj: any,
        signal: AbortSignal
    ): Promise<any> {

        let { data } = await api.post(`${this.baseURL}`,
            obj,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                    "Content-Type": "multipart/form-data",
                },
                signal
            });

        return data;
    }

    async putGestorMembro(
        id: string | number,
        obj: any,
        signal: AbortSignal
    ): Promise<any> {

        let { data } = await api.put(`${this.baseURL}/${id}`,
            obj,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                    "Content-Type": "multipart/form-data",
                },
                signal
            });

        return data;
    }

    async deleteGestorMembro(
        id: string | number,
        signal: AbortSignal
    ): Promise<any> {

        let { data } = await api.delete(`${this.baseURL}/${id}`,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }

}

// eslint-disable-next-line import/no-anonymous-default-export
export default new MembrosService();
